import React from 'react'
import { WEISCHER_PREROLL } from '../../../client/js/constants/weischerTypes'
import config from '../config.json'
import { MAINSLIDER } from '../constants/selectionTypes'
import MainSliderSelection from '../SelectionsDisplayList/MainSliderSelection'


const MainSliderWrapper = ({
    itemSelectionsDisplay, 
    attributeStyling, 
    features, 
    itemSelections, 
    theme, 
    translation, 
    moviesRoutesData, 
    hiddenAttributes,
    weischerAds, 
    informationStyling, 
    itemCollections, 
    showAvailableIn,
    ads,
    ignoreAttributesForPerformanceFilter,
    elbenwald,
    sliderAppearance,
    detailsStyling,
    advertisements,
    movies, 
    mainSliderAdvertisementPositioning,
    currentActiveSelection, 
    setIdForActiveSelection,
    isConnectedFast
}) => {
    if(_.isEmpty(itemSelectionsDisplay)) {
        return ''
    }

    const sliderSettings = config.sliderSettings
    const { basicSettings } = sliderSettings
    const itemSelectionsDisplayOrder = itemSelectionsDisplay.order
    const itemSelectionsDisplayItems = itemSelectionsDisplay.items

    const mainId = itemSelectionsDisplayOrder.find(itemSelectionDisplayID => {
        const item = itemSelectionsDisplayItems[itemSelectionDisplayID]
        const { type } =  item 

        return MAINSLIDER === type
    })
    if(!mainId){
        return ''
    }

    const itemMain = itemSelectionsDisplayItems[mainId]
    const { selectionId } = itemMain
    const itemSelection = itemSelections[selectionId]

    return (
        <div className="slider-front">
            <div>
                <MainSliderSelection 
                    selectionId={selectionId}
                    itemSelection={itemSelection}
                    hiddenAttributes={hiddenAttributes}
                    detailsStyling={detailsStyling}
                    attributeStyling={attributeStyling}
                    ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                    sliderAppearance={sliderAppearance}
                    showAvailableIn={showAvailableIn}
                    itemCollections={itemCollections} 
                    ads={ads} 
                    mainSliderAdvertisementPositioning={mainSliderAdvertisementPositioning}
                    advertisements={advertisements}
                    informationStyling={informationStyling} 
                    weischerAds={weischerAds} 
                    elbenwald={elbenwald}
                    theme={theme}
                    type={itemMain.type}
                    translation={translation}
                    moviesRoutesData={moviesRoutesData}
                    movies={movies} 
                    sliderSettings={basicSettings}
                    currentActiveSelection={currentActiveSelection}
                    setIdForActiveSelection={setIdForActiveSelection}
                    features={features}
                    isConnectedFast={isConnectedFast}
                />
            </div>
        </div>
    )
}

export default MainSliderWrapper